import React from "react"
import masyLogo from "../images/masyLogo.png"
import { AiTwotoneMail } from "@react-icons/all-files/ai/AiTwotoneMail"

/* This example requires Tailwind CSS v2.0+ */
const navigation = {
  sitemap: [
    { name: "Curriculum", href: "/curriculum" },
    { name: "Resources", href: "/resources" },
    { name: "Services", href: "/services" },
    {
      name: "Book a Consultation",
      href: "https://docs.google.com/forms/d/e/1FAIpQLScUpuMuYd4tVZD4wD8NKpiTERRKpJPTr6BN8FpO6HvObw-Diw/viewform",
    },
  ],
  contact: [{ icon: AiTwotoneMail, text: "masyconsultants@gmail.com" }],
  company: [
    { name: "About", href: "#" },
    { name: "Blog", href: "#" },
    { name: "Jobs", href: "#" },
    { name: "Press", href: "#" },
    { name: "Partners", href: "#" },
  ],
  legal: [
    { name: "Claim", href: "#" },
    { name: "Privacy", href: "#" },
    { name: "Terms", href: "#" },
  ],
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/MasyConsultants/",
      icon: props => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/company/masyconsultants",
      icon: props => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: "Youtube",
      href: "https://www.youtube.com/watch?v=C3frG1I2S30",
      icon: props => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      ),
    },
  ],
}

export default function NewFooter() {
  return (
    <footer className="bg-white" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="flex justify-center md:grid md:grid-cols-2 md:gap-6 xl:grid xl:grid-cols-2 xl:gap-8 grid grid-cols-1">
          <div className="space-y-8 col-span-1">
            <a href="https://www.masyconsultants.org/" target="_blank">
              <img className="h-14 w-auto" src={masyLogo} alt="" />
            </a>
            <p className="text-gray-500 text-base">
              © 2022 Developed. Curated. Engineered by Masy Consultants. All
              rights reserved.
            </p>
            <div className="flex space-x-6">
              {navigation.social.map(item => (
                <a
                  key={item.name}
                  href={item.href}
                  target="__blank"
                  className="text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
          <div className="sm:mt-12 grid grid-cols-1 md:grid md:grid-cols-2 lg:grid lg:grid-cols-2  gap-8 xl:mt-0 xl:col-span-1">
            <div className="mt-5 md:mt-0 lg:mt-0">
              <h3 className="text-sm font-semibold text-black md:text-gray-400 tracking-wider uppercase">
                Sitemap
              </h3>
              <ul
                role="list"
                className="mt-2 md:mt-4 lg:mt-4 space-y-1 md:space-y-4 lg:space-y-4"
              >
                {navigation.sitemap.map(item => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-base text-gray-500 hover:text-gray-900"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="md:mt-0">
              <h3 className="text-sm font-semibold text-black md:text-gray-400 uppercase">
                Contact Information
              </h3>
              <ul
                role="list"
                className="w-fit mt-2 md:mt-4 lg:mt-4 space-y-1 md:space-y-4 lg:space-y-4"
              >
                {navigation.contact.map(item => (
                  <li className="md:w-full flex flex-row items-center gap-2 text-gray-500 inline">
                    <item.icon className="h-4 w-4" />
                    <p className="md:text-xs lg:text-base">
                      {" "}
                      masyconsultants@gmail.com
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
